// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'personnel/:pathMatch(.*)?',
        name: consts.routerNames.personnel.main,
        meta: {
            list: 'PersonnelList',
            mainRouteName: consts.routerNames.personnel.main,
            showMap: true,
            layers: consts.defaultSettingsLayers,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/portal/PersonnelPage.vue')
    },
];

export default routes;